export const FIREBASE_BULK_JOBS_COLLECTION = "ti_bulk_jobs";
export const FIREBASE_BULK_IMPORTS_COLLECTION = "ti_bulk_imports";
export const FIREBASE_DWD_SYNC_JOBS_COLLECTION = "ti_dwd_sync_jobs";
export const FIREBASE_NOTIFICATIONS_COLLECTION = "ti_notifications";
